import update from 'immutability-helper'

export function setToTrueFalse(question) {
	const newChoices=[
		{
			body:'True',
			correct:true,
		},
		{
			body:'False',
			correct:false,
		},
	]

	const updatedQuestion=update(question,
		{choices:  
			{$set: newChoices
			}})

	return updatedQuestion
}



